import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import apiService, { handleError } from "../../Common/ApiCommon/ApiService";

// Create AsyncThunk for fetching category details
export const getCategoryDetails = createAsyncThunk(
  'categories/getCategoryDetails',
  async (Params, { rejectWithValue }) => {
    try {
      const response = await apiService.get(`/canteen_categories?${Params}`);
      return response.canteen_categories;
    } catch (errors) {
      handleError(errors);
      return rejectWithValue(errors?.response?.data?.errors || errors.message);
    }
  }
);


// Create the Redux Slice
const categorySlice = createSlice({
  name: 'categories',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getCategoryDetails.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getCategoryDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getCategoryDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default categorySlice.reducer;